export enum TsepEventType {
  FOCUS_ON = 'FocusOnEvent',
  FOCUS_OUT = 'FocusOutEvent',
  BLUR = 'BlurEvent',
  FIELD_VALIDATON_ERROR = 'FieldValidationErrorEvent',
  ERROR = 'ErrorEvent',
  TOKEN = 'TokenEvent',
}
